import {
    Component,
    type ErrorInfo,
    type PropsWithChildren,
    type ReactNode,
} from "react";
import { history } from "../../_Bootstrap/RoutingAndStore";
import RenderError from "../../Layout/Body/RenderError";
import { RenderNetworkError } from "../../Layout/Body/RenderNetworkError";

export class ErrorBoundary extends Component<PropsWithChildren, {
    renderError: boolean;
    networkError: boolean;
}> {
    protected stopListening = (): void => { /* no-op */ };

    public state = {
        renderError : false,
        networkError: false,
    };

    public componentDidMount(): void {
        this.stopListening = history.listen(this.handleLocationChange);
    }

    public componentWillUnmount(): void {
        this.stopListening();
    }

    protected handleLocationChange = (): void => {
        this.setState({
            renderError : false,
            networkError: false,
        });
    };

    protected isWebpackError(error: Error): boolean {
        return (
            "request" in error && (
                ("code" in error && (error.code as string).toUpperCase().includes("CHUNK")) ||
                ("name" in error && error.name.toUpperCase().includes("CHUNK"))
            )
        );
    }

    public componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
        if(this.isWebpackError(error)) {
            this.setState({
                networkError: true,
            });

            return;
        }

        console.error("Error caught by Shopfront (react component)", error, errorInfo);
        this.setState({
            renderError: true,
        });
    }

    public render(): ReactNode {
        if(this.state.networkError) {
            return (
                <RenderNetworkError onClear={() => this.setState({ networkError: false })} />
            );
        }

        if(this.state.renderError) {
            return (
                <RenderError />
            );
        }

        return this.props.children;
    }
}
